/**
 * Limit the target number between min and max.
 * Default value of min and max is Number.NEGATIVE_INFINITY
 * and Number.POSITIVE_INFINITY.
 */
export var limitNumberBetween = function (target, min, max) {
    if (min === void 0) { min = Number.NEGATIVE_INFINITY; }
    if (max === void 0) { max = Number.POSITIVE_INFINITY; }
    return Math.max(Math.min(target, max), min);
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
export var NO_OP = function () { };
